import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HeaderRootMenu from './HeaderRootMenu'
import ClientBranchBreadcrumb from './ClientBranchBreadcrumb'
import ClientSettings from './ClientSettings'

const HeaderInternal = () => (
  <>
    <Routes>
      <Route
        path="/clients/:accountId/*"
        element={<ClientBranchBreadcrumb />}
      />
    </Routes>

    <div className="header_separator" />

    <Routes>
      <Route path="/clients/:accountId/*" element={<ClientSettings />} />
      <Route path="*" element={<HeaderRootMenu />} />
    </Routes>
  </>
)

export default HeaderInternal
